const projectsArray = [
  {
    title: "Meals On Wheels Project (Online Meal Cart)",
    sourceCode: "",
    imageUrl:
      "https://imageio.forbes.com/specials-images/imageserve/628e3814b2b4253c117d4f13/Dining-Column-on-New-Heights-Restaurant/960x0.jpg?format=jpg&width=960",
    content:
      "Meals On Wheels is an Online Meal Cart project as 1st Year 2nd Semester IWT project.",
    stack: [
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-html.svg",
        name: "HTML",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-css.svg",
        name: "CSS",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-js-official.svg",
        name: "JavaScript",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-php.svg",
        name: "PHP",
        link: "",
      },
      {
        icon: "https://api.iconify.design/logos/bootstrap.svg",
        name: "Bootstrap",
        link: "",
      },
      {
        icon: "https://api.iconify.design/logos/mysql.svg",
        name: "MySQL",
        link: "",
      },
    ],
  },
  {
    title: "School Information Management System (SIMS)",
    sourceCode: "",
    imageUrl:
      "https://www.brookings.edu/wp-content/uploads/2020/10/SUBSTITUTE-TEACHER-RYAN-GIESE-TEACHES-A-FOURTH-GRADE-CLASS.jpg",
    content:
      "School Information Management System project as 2nd Year 1nd Semester OOP project.",
    stack: [
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-html.svg",
        name: "HTML",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-css.svg",
        name: "CSS",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-js-official.svg",
        name: "JavaScript",
        link: "",
      },
      {
        icon: "https://api.iconify.design/logos/java.svg",
        name: "Java",
        link: "",
      },
      {
        icon: "https://api.iconify.design/logos/bootstrap.svg",
        name: "Bootstrap",
        link: "",
      },
      {
        icon: "https://api.iconify.design/logos/mysql.svg",
        name: "MySQL",
        link: "",
      },
    ],
  },
  {
    title: "Human Resource Information System (HRIS)",
    sourceCode: "",
    imageUrl:
      "https://lirp.cdn-website.com/537b6562/dms3rep/multi/opt/Information+Systems+in+Human+Resource+Management-1920w.jpg",
    content:
      "Human Resource Information System project is a web application based on MEAN stack as 2nd Year 2nd Semester ITP project.",
    stack: [
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-html.svg",
        name: "HTML",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-css.svg",
        name: "CSS",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-js-official.svg",
        name: "JavaScript",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-angular.svg",
        name: "Angular",
        link: "",
      },
      {
        icon: "https://api.iconify.design/logos/nodejs-icon.svg",
        name: "NodeJS",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-mongo.svg",
        name: "MongoDB",
        link: "",
      },
    ],
  },
  {
    title: "Hotel Management System (Native Android Mobile Application)",
    sourceCode: "",
    imageUrl:
      "https://pix10.agoda.net/hotelImages/124/1246280/1246280_16061017110043391702.jpg?ca=6&ce=1&s=1024x768",
    content:
      "Hotel Management System project is an Native Android mobile application as 2nd Year 2nd Semester MAD project.",
    stack: [
      {
        icon: "https://api.iconify.design/flat-color-icons/android-os.svg",
        name: "Android Studio",
        link: "",
      },
      {
        icon: "https://api.iconify.design/logos/java.svg",
        name: "Java",
        link: "",
      },
      {
        icon: "https://api.iconify.design/logos/firebase.svg",
        name: "Firebase",
        link: "",
      },
    ],
  },
  {
    title: "Conference Management System",
    sourceCode: "https://github.com/thushaltk/AF-PROJECT-FRONTEND",
    imageUrl:
      "https://www.incimages.com/uploaded_files/image/1920x1080/getty_499517325_111832.jpg",
    content:
      "Conference Management System project is a web application based on MERN stack as 3rd Year 1st Semester AF project.",
    stack: [
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-html.svg",
        name: "HTML",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-css.svg",
        name: "CSS",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-js-official.svg",
        name: "JavaScript",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-reactts.svg",
        name: "ReactJS",
        link: "",
      },
      {
        icon: "https://api.iconify.design/logos/nodejs-icon.svg",
        name: "NodeJS",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-mongo.svg",
        name: "MongoDB",
        link: "",
      },
    ],
  },
  {
    title: "Procurement Management System",
    sourceCode: "",
    imageUrl:
      "https://whatfix.com/blog/wp-content/uploads/2022/04/procurement.png",
    content:
      "Procurement Management System project is a web application based on MERN stack as the 3rd Year 2nd Semester CSSE project.",
    stack: [
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-html.svg",
        name: "HTML",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-css.svg",
        name: "CSS",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-js-official.svg",
        name: "JavaScript",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-reactts.svg",
        name: "ReactJS",
        link: "",
      },
      {
        icon: "https://api.iconify.design/logos/nodejs-icon.svg",
        name: "NodeJS",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-mongo.svg",
        name: "MongoDB",
        link: "",
      },
    ],
  },
  {
    title: "Humanoid - Human Body Explorer (Mobile App)",
    sourceCode: "",
    imageUrl:
      "https://anatomylearning.com/wp-content/uploads/2021/08/Portada-2000-x1200-2.jpg",
    content:
      "Humanoid is a cross-platform mobile application developed using Flutter framework including dart programming language and Firebase firestore database.",
    stack: [
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-flutter.svg",
        name: "Flutter",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-dartlang.svg",
        name: "Dart",
        link: "",
      },
      {
        icon: "https://api.iconify.design/vscode-icons/file-type-firebase.svg",
        name: "Firebase",
        link: "",
      },
    ],
  },
  {
    title: "FuelUpp - Fuel Distribution App (Mobile App)",
    sourceCode: "",
    imageUrl:
      "https://static.vecteezy.com/system/resources/thumbnails/006/766/774/small/gas-station-in-cartoon-style-free-vector.jpg",
    content:
      "FuelUpp is a native-android mobile application developed using Android Studio (Java) to manage vehicle fuel distribution and queue management.",
    stack: [
      {
        icon: "https://api.iconify.design/flat-color-icons/android-os.svg",
        name: "Android Studio",
        link: "",
      },
      {
        icon: "https://api.iconify.design/logos/java.svg",
        name: "Java",
        link: "",
      },
      {
        icon: "https://api.iconify.design/logos/firebase.svg",
        name: "Firebase",
        link: "",
      },
    ],
  },
];

module.exports = {
  projectsArray,
};
